module.exports = __webpack_public_path__ + "img/source2.b3b936f0.png";